<template>
  <div v-title :data-title="$route.name">
    <!-- style=" border-style: solid; border-width: 5px; border-color: transparent;" -->
    <div ref="myElement" style="background: white">
      <header
        v-if="offsetwidth > 850"
        class="l-header clearfix corporate-layout"
      >
        <div class="contain-to-grid clearfix sticky">
          <nav class="top-bar" data-topbar>
            <div class="centred-logo-info">
              <ul class="title-area">
                <li class="name">
                  <h1>
                    <a href="/" rel="home" title="Smart User">
                      <img src="../assets/img/logo-1.png" alt="Smart User" />
                    </a>
                  </h1>
                </li>
                <li class="toggle-topbar menu-icon">
                  <a href="#"><span>Menu</span></a>
                </li>
              </ul>
              <div class="address-container">
                <div class="address-bar-left">
                  <div class="address_bar">
                    <div class="address_icon">
                      <img src="../assets/img/phone.png" alt="icon" />
                    </div>
                    <ul class="bar">
                      <li class="address">Call Us Today</li>
                      <li class="text_add">(03) 8528 1831</li>
                    </ul>
                  </div>
                  <div class="address_bar">
                    <div class="address_icon">
                      <img src="../assets/img/email.png" alt="icon" />
                    </div>
                    <ul class="bar">
                      <li class="address">Email</li>
                      <li class="text_add">info@smartuser.com.au</li>
                    </ul>
                  </div>
                </div>
                <div class="address-bar-right">
                  <div class="address_bar">
                    <div class="address_icon">
                      <img src="../assets/img/clock.png" alt="icon" />
                    </div>
                    <ul class="bar">
                      <li class="address">Work Time</li>
                      <li class="text_add">09.30-17.30</li>
                    </ul>
                  </div>
                  <div class="address_bar">
                    <div class="address_icon">
                      <img src="../assets/img/map-marker.png" alt="icon" />
                    </div>
                    <ul class="bar">
                      <li class="address">Address</li>
                      <li class="text_add">
                        11 Howleys Road, Notting Hill, VIC 3168
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
        <!--/.top-Menu -->
      </header>
      <div
        v-if="offsetwidth > 850"
        style="
          width: 100%;
          height: 100%;
          overflow: hidden;
          position: relative;
          min-width: 1425px;
        "
      >
        <!-- <div class="page-section home-page" id="page-content"> -->
        <!--.l-header region -->

        <!-- </div> -->
        <!-- <img style="width: 100%" src="../assets/img/抬头.jpg" alt="" /> -->

        <div style="position: relative">
          <img style="width: 100%" src="../assets/img/表格背景图.jpg" alt="" />
          <div
            class="pchome"
            style="
              border-style: solid;
              border-color: transparent;
              border-width: 5px;
              position: absolute;
              top: 20%;
              right: 10.5%;
              color: black;
              width: 25%;
              height: 62%;
            "
          >
            <div
              style="color: rgb(39, 95, 180); white-space: nowrap"
              :class="offsetwidth > 1425 ? 'dacss' : 'xicss'"
            >
              VEU Rebate Eligibility check
            </div>
            <div
              style="text-align: left"
              v-if="showconnet == 0"
              :class="offsetwidth > 1425 ? 'mt_20' : 'mt_5'"
            >
              How to get a Quote?
            </div>
            <div
              v-if="showconnet == 0"
              :class="offsetwidth > 1425 ? 'mt_20' : 'mt_5'"
              style="
                width: 100%;
                height: 10px;
                background-color: rgb(179, 212, 101);
                border-radius: 20px;
              "
            ></div>

            <el-form
              v-if="showconnet == 0"
              :class="offsetwidth > 1425 ? 'mt_20' : 'mt_5'"
              ref="addUserForm1"
              :model="addUserForm1"
              :rules="addUserRule"
              auto-complete="on"
            >
              <el-form-item prop="FirstName">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="addUserForm1.FirstName"
                  placeholder="First Name*"
                ></el-input>
              </el-form-item>
              <el-form-item prop="LastName">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="addUserForm1.LastName"
                  placeholder="Last Name*"
                ></el-input>
              </el-form-item>

              <el-form-item prop="Phone">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="addUserForm1.Phone"
                  placeholder="Phone Number*"
                ></el-input>
              </el-form-item>
              <el-form-item prop="Address">
                <el-input
                  style="width: 100%"
                  clearable
                  @focus="geolocate()"
                  name="autocomplete"
                  id="autocompletepc"
                  autocomplete="off"
                  v-model="addUserForm1.Address"
                ></el-input>
              </el-form-item>
              <el-form-item prop="System">
                <el-select
                  v-model="addUserForm1.System"
                  style="width: 100%"
                  clearable
                  placeholder="Existing Heating System*"
                >
                  <el-option
                    v-for="item in Systemopt"
                    :key="item.tag"
                    :value="item.tag"
                    :label="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <div
              style="margin-top: 60px; width: 100%; height: 260px"
              v-if="showconnet == 'A/C'"
            >
              Unfortunately, without an existing ducted gas heater, you don't
              qualify for the VEU Rebate under Aclivity 6(vii). But feel free to
              browse our website for other options that might interest you,
              Thanks for your understanding.
            </div>
            <div
              style="
                margin-top: 60px;
                width: 100%;
                height: 260px;
                text-align: center;
              "
              v-if="showconnet != 'A/C' && showconnet != 0"
            >
              <div>Thank you for your insterest!</div>
              <div>We will contact you in 2 business days!</div>
            </div>
            <div
              @click="Submitform1()"
              v-if="showconnet != 0"
              style="
                width: 100%;
                height: 8%;
                background-color: rgb(39, 95, 180);
                color: white;
                border-radius: 20px;
                font-size: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                margin-top: 0px;
              "
            >
              Done
            </div>
            <div
              style="display: flex; justify-content: space-between"
              :class="offsetwidth > 1425 ? 'mt_40' : 'mt_5'"
            >
              <div
                style="
                  text-decoration: underline;
                  color: rgb(39, 95, 180);
                  cursor: pointer;
                "
                @click="gotopri()"
              >
                Privacy Policy*
              </div>
              <div
                style="
                  text-decoration: underline;
                  color: rgb(39, 95, 180);
                  cursor: pointer;
                "
                @click="gotoTerms()"
              >
                Terms & conditions*
              </div>
            </div>
            <div
              v-if="showconnet == 0"
              :class="offsetwidth > 1425 ? 'mt_20' : 'mt_5'"
              @click="GetaFREE()"
              style="
                width: 100%;
                height: 8%;
                background-color: rgb(39, 95, 180);
                color: white;
                border-radius: 20px;
                font-size: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                margin-top: 10px;
              "
            >
              Get a FREE Quotation
            </div>
          </div>

          <div></div>
        </div>
        <img style="width: 100%" src="../assets/img/大图.jpg" alt="" />
      </div>
      <div
        v-else
        style="width: 100%; height: 100%; overflow: hidden; position: relative"
      >
        <img
          style="width: 100%"
          src="../assets/img/H5抬头.jpg"
          alt=""
          @click="goto()"
        />
        <div style="position: relative">
          <img style="width: 100%" src="../assets/img/H5.jpg" alt="" />
          <div
            style="
              border-style: solid;
              border-color: transparent;
              border-width: 5px;
              position: absolute;
              top: 8%;
              right: 5%;
              color: black;
              width: 90%;
              height: 62%;
            "
          >
            <div
              style="color: rgb(39, 95, 180)"
              :class="offsetwidth > 1425 ? 'dacss' : 'xicss'"
            >
              VEU Rebate Eligibility check
            </div>
            <div
              style="text-align: left"
              v-if="showconnet == 0"
              :class="offsetwidth > 1425 ? 'mt_20' : 'mt_5'"
            >
              How to get a Quote?
            </div>
            <div
              v-if="showconnet == 0"
              :class="offsetwidth > 1425 ? 'mt_20' : 'mt_5'"
              style="
                width: 100%;
                height: 10px;
                background-color: rgb(179, 212, 101);
                border-radius: 20px;
              "
            ></div>

            <el-form
              v-if="showconnet == 0"
              class="mt_10"
              ref="addUserForm1"
              :model="addUserForm1"
              :rules="addUserRule"
              auto-complete="on"
            >
              <el-form-item prop="FirstName">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="addUserForm1.FirstName"
                  placeholder="First Name*"
                ></el-input>
              </el-form-item>
              <el-form-item prop="LastName">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="addUserForm1.LastName"
                  placeholder="Last Name*"
                ></el-input>
              </el-form-item>

              <el-form-item prop="Phone">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="addUserForm1.Phone"
                  placeholder="Phone Number*"
                ></el-input>
              </el-form-item>
              <el-form-item prop="Address">
                <el-input
                  style="width: 100%"
                  clearable
                  @focus="geolocate()"
                  name="autocomplete"
                  id="autocompleteh5"
                  autocomplete="off"
                  v-model="addUserForm1.Address"
                ></el-input>
              </el-form-item>
              <el-form-item prop="System">
                <el-select
                  v-model="addUserForm1.System"
                  style="width: 100%"
                  clearable
                  placeholder="Existing Heating System*"
                >
                  <el-option
                    v-for="item in Systemopt"
                    :key="item.tag"
                    :value="item.tag"
                    :label="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <div
              style="margin-top: 60px; width: 100%; height: 260px"
              v-if="showconnet == 'A/C'"
            >
              Unfortunately, without an existing ducted gas heater, you don't
              qualify for the VEU Rebate under Aclivity 6(vii). But feel free to
              browse our website for other options that might interest you,
              Thanks for your understanding.
            </div>
            <div
              style="
                margin-top: 60px;
                width: 100%;
                height: 260px;
                text-align: center;
              "
              v-if="showconnet != 'A/C' && showconnet != 0"
            >
              <div>Thank you for your insterest!</div>
              <div>We will contact you in 2 business days!</div>
            </div>
            <div
              @click="Submitform1()"
              v-if="showconnet != 0"
              style="
                width: 100%;
                height: 8%;
                background-color: rgb(39, 95, 180);
                color: white;
                border-radius: 20px;
                font-size: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                margin-top: 30px;
              "
            >
              Done
            </div>
            <div
              style="display: flex; justify-content: space-between"
              class="mt_15"
            >
              <div
                style="
                  text-decoration: underline;
                  color: rgb(39, 95, 180);
                  cursor: pointer;
                "
                @click="gotopri()"
              >
                Privacy Policy*
              </div>
              <div
                style="
                  text-decoration: underline;
                  color: rgb(39, 95, 180);
                  cursor: pointer;
                "
                @click="gotoTerms()"
              >
                Terms & conditions*
              </div>
            </div>
            <div
              v-if="showconnet == 0"
              @click="GetaFREE()"
              style="
                width: 100%;
                height: 9%;
                background-color: rgb(39, 95, 180);
                color: white;
                border-radius: 20px;
                font-size: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                margin-top: 10%;
              "
            >
              Get a FREE Quotation
            </div>
          </div>
        </div>
        <img style="width: 100%" src="../assets/img/H5大图1.jpg" alt="" />
        <img style="width: 100%" src="../assets/img/H5大图2.jpg" alt="" />
      </div>
    </div>
    <GMaps
      v-show="false"
      class="Gmaps"
      @fun="getinfo"
      :offsetwidth="offsetwidth"
      ref="child"
      :map-data="mapData"
    />
  </div>
</template>

<script>
import GMaps from "@/components/mapcopy/Gmaps";
import { get, post } from "../assets/api/apicopy";
export default {
  components: { GMaps },
  data() {
    const checkphone = (rule, value, callback) => {
      let reg = /^[0][3,4][0-9]{8}$/;
      if (!reg.test(value)) {
        return callback(new Error(`Please provide a valid phone number. `));
      }
      callback();
    };
    const regemail = (rule, value, callback) => {
      let reg =
        /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
      if (!reg.test(value) && value) {
        return callback(new Error("The email format is not correct."));
      }
      callback();
    };
    const notNull = (rule, value, callback) => {
      // console.log(value)
      if (!value) {
        return callback(new Error(`${rule.field} is required `));
      }
      callback();
    };
    const checkpostcode = (rule, value, callback) => {
      let reg = /^3[0-9]{3}$/;
      if (!reg.test(value)) {
        return callback(new Error(`${rule.field} is required `));
      }

      callback();
    };
    return {
      mapData: {
        latitude: 33.242,
        longitude: 124.12,
      },
      showconnet: "0",
      addUserRule: {
        FirstName: [
          {
            validator: notNull,
            trigger: ["change", "blur"],
          },
        ],
        LastName: [
          {
            validator: notNull,
            trigger: ["change", "blur"],
          },
        ],
        Address: [
          {
            validator: notNull,
            trigger: ["change", "blur"],
          },
        ],
        Phone: [
          {
            validator: notNull,
            trigger: ["change", "blur"],
          },
          {
            validator: checkphone,
            len: 10,
            trigger: ["change", "blur"],
          },
        ],

        System: [
          {
            validator: notNull,
            trigger: ["change", "blur"],
          },
        ],
      },
      Systemopt: [
        { tag: "Central Gas Heating", value: "Central Gas Heating" },
        { tag: "A/C", value: "A/C" },
        { tag: "Other", value: "Other" },
        { tag: "Not sure", value: "Not sure" },
      ],
      addUserForm1: {
        FirstName: "",
        LastName: "",
        Address: "",
        Phone: "",
        System: "",
        Suburb: "",
        Postcode: "",
        streetName: "",
        Street_number: "",
        City: "",
      },

      offsetwidth: document.documentElement.clientWidth,
    };
  },
  watch: {
    // 如果 `offset ` 发生改变，这个函数就会运行
    offsetwidth: function (val) {
      if (!this.timer) {
        this.offsetwidth = val;
        // this.showmenu = this.offsetwidth > 700;
        // this.changeheight(val);
        this.timer = true;
        let that = this;
        let timeout = setTimeout(function () {
          // clearTimeout(timeout);/
          //频繁触发 resize 函数，会导致页面很卡
          that.timer = false;
        }, 100);
      }
    },
  },
  mounted() {
    let that = this;
    window.addEventListener("resize", () => {
      window.offsetwidth = document.documentElement.clientWidth;
      that.offsetwidth = window.offsetwidth;
    });
    // window.addEventListener("resize", this.handleResize);
  },
  // beforeDestroy() {
  //   window.removeEventListener("resize", this.handleResize);
  // },
  methods: {
    gotoTerms() {
      window.open("/Termsconditions", "_blank");
    },
    gotopri() {
      window.open("/privacy-policy", "_blank");
    },
    geolocate() {
      this.$refs.child.geolocate;
    },
    initAutocomplete() {
      this.$refs.child.initAutocomplete;
    },
    fillInAddress() {
      this.$refs.child.fillInAddress;
    },
    //获取组件中的谷歌地图信息
    getinfo(data) {
      if (data.tag == "placepc" || data.tag == "placeh5") {
        this.addUserForm1.Address = data.address;
        this.addUserForm1.Suburb = data.locality;
        this.addUserForm1.Postcode = data.postal_code;
        this.addUserForm1.streetName = data.route;
        this.addUserForm1.Street_number = data.street_number;
        this.addUserForm1.City = data.administrative_area_level_2;
        if (this.addUserForm1.streetName === "long_name") {
          this.addUserForm1.streetName = "";
        }
        if (this.addUserForm1.Suburb === "long_name") {
          this.addUserForm1.Suburb = "";
        }
        if (this.addUserForm1.Street_number === "short_name") {
          this.addUserForm1.Street_number = "";
        }
        if (this.addUserForm1.Postcode === "short_name") {
          this.addUserForm1.Postcode = "";
        }
        if (this.addUserForm1.City === "short_name") {
          this.addUserForm1.City = "";
        }
      }
    },
    // 添加防抖函数
    debounce(fn, delay) {
      let timer = null;
      return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, arguments);
        }, delay);
      };
    },
    handleResize() {
      this.offsetwidth = window.innerWidth; // 动态更新
    },
    GetaFREE() {
      this.$refs.addUserForm1.validate((valid) => {
        if (valid) {
          if (this.addUserForm1.System == "A/C") {
            this.showconnet = "A/C";
          } else if (this.addUserForm1.System != "A/C") {
            this.showconnet = "other";
          }
        }
      });
    },
    goto() {
      window.open("/", "_blank");
    },
    Submitform1() {
      if (this.showconnet == "other") {
        let data = {
          To_Store_ID: 52,
          FirstName: this.addUserForm1.FirstName,
          LastName: this.addUserForm1.LastName,
          Phone: this.addUserForm1.Phone,
          Optional: "",
          Centralgasheatling: "Yes",
          Storey: "Single Storey",
          // Emailaddress: this.form.Emailaddress,
          Address: this.addUserForm1.Address,
          Unit_Number: "",
          Street_Number: this.addUserForm1.Street_number,
          Street_Name: this.addUserForm1.streetName,
          Suburb: this.addUserForm1.Suburb,
          City: this.addUserForm1.City,
          PostCode: this.addUserForm1.Postcode,
          Language: "English",
          ToSalesID: 20267,
          Pro_SH: 0,
          Pro_IHD: 0,
          Pro_DS: 0,
          Pro_CS: 0,
          Pro_LED: 0,
          Pro_FS: 0,
          Pro_AC: 0,
          Pro_SP: 0,
          Pro_HP: 0,
          Pro_MAC: 1,
          Pro_RHP: 0,
          // Dimmer: this.form.Dimmer,
          // LEDNumber: this.form.LEDNumber,
          // CeilingHeight: this.form.cell_height,
          // SHNumber: this.form.SHNumber,
          // FreeLED: this.form.FreeLED,
        };
        post("/api/api/QR_CustomerOrders/AddOrder", data).then((res) => {
          if (res.data.code == 201) {
            (this.addUserForm1 = {
              FirstName: "",
              LastName: "",
              Address: "",
              Phone: "",
              System: "",
              Suburb: "",
              Postcode: "",
              streetName: "",
              Street_number: "",
              City: "",
            }),
              this.$message.success("Successful.");
            window.open("/", "_blank");
            // setTimeout(() => {

            // }, 3000);
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 2500,
            });
          }
        });
      } else {
        window.open("/", "_blank");
      }
      // this.$refs.addUserForm1.validate((valid) => {
      //   if (valid) {
      //     console.log(this.addUserForm1);

      //   this.formdata = {
      //     To_Store_ID: 117,
      //     FirstName: this.addUserForm1.FirstName,
      //     LastName: this.addUserForm1.LastName,
      //     Phone: this.addUserForm1.Phone,
      //     Emailaddress: this.addUserForm1.Email,
      //     PostCode: this.addUserForm1.Postcode,
      //     Address: this.addUserForm1.Address,
      //     Unit_Number: "",
      //     Street_Number: this.addUserForm1.Street_number,
      //     Street_Name: this.addUserForm1.streetName,
      //     Suburb: this.addUserForm1.Suburb,
      //     City: this.addUserForm1.City,
      //     Language: "",
      //     ToSalesID: 20183,
      //     Pro_SH: 0,
      //     Pro_IHD: 0,
      //     Pro_DS: 0,
      //     Pro_CS: 0,
      //     Pro_LED: 0,
      //     Pro_FS: 0,
      //     Pro_AC: 0,
      //     Pro_SP: 1,
      //     Pro_HP: 0,
      //     Pro_MAC: 0,
      //   };
      // console.log(this.formdata)

      //   }
      // });
    },
    // goinfo() {
    //   // window.sessionStorage.setItem("activeIndex", "/CustomerDetails");
    //   this.$emit("fun", "/CustomerDetails");
    // },
  },
};
</script>

<style scoped>
.mb_20 {
  margin-bottom: 20px;
}
.special-link {
  text-decoration: underline;
}
a:link {
  color: blue;
}
/* 已访问的链接 */
a:visited {
  color: purple;
}

/* 鼠标悬浮在链接上 */
a:hover {
  color: red;
}

/* 链接被点击时 */
a:active {
  color: yellow;
}
.mt_20 {
  margin-top: 20px;
}
.mt_10 {
  margin-top: 10px;
}
.mt_15 {
  margin-top: 15px;
}
.text_bold {
  font-weight: 700;
}
::v-deep.el-form-item {
  margin-bottom: 5px;
}
::v-deep .el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 0;
  position: absolute;
  top: calc(100% - 10px); /* 更靠近输入框 */
  left: 0;
  margin-top: 0;
}

.dacss {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  margin-top: 20px;
}
.xicss {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  margin-top: 5px;
}
.mt_20 {
  margin-top: 20px;
}
.mt_5 {
  margin-top: 5px;
}
.mt_40 {
  margin-top: 65px;
}
</style>
